import { render } from "./LoyaltyProgram.vue?vue&type=template&id=7f7d97bb&scoped=true"
import script from "./LoyaltyProgram.vue?vue&type=script&lang=js"
export * from "./LoyaltyProgram.vue?vue&type=script&lang=js"

import "./LoyaltyProgram.vue?vue&type=style&index=0&id=7f7d97bb&scoped=true&lang=scss"

import exportComponent from "C:\\flexites\\1lombard\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7d97bb"]])

export default __exports__